<template>
    <div class="d-flex">
        <ButtonComp
            :icon="dropdownItem.props.icon"
            :icon-position="dropdownItem.props.iconPosition"
            :button-type="dropdownItem.props.buttonType ?? 'Custom'"
            :textposition="dropdownItem.props.textposition ?? 'left'"
            class="flex-fill"
            :class="dropdownItem.class"
            @click="runAction"
            v-bind="$attrs"
            :title="dropdownItem.props.title ? $tm(unref(dropdownItem.props.title)) : undefined"
            :disabled="dropdownItem.props.disabled"
        >
            <div
                class="d-flex gap-3 flex-nowrap"
                v-if="dropdownItem.translationkey"
            >
                <MarkText
                    class="flex-fill"
                    :text="$tm(unref(dropdownItem.translationkey))"
                    :markPart="unref(dropdownItem.markTextPart)"
                />
                <span
                    class="display-6 align-self-center"
                    :class="dropdownItem.subtextclass"
                    v-if="dropdownItem.subtext"
                >
                    {{ dropdownItem.subtext }}
                </span>
                <TooltipHelp
                    v-if="dropdownItem.tooltip"
                    :text="unref(dropdownItem.tooltip)"
                />
                <small
                    v-if="dropdownItem.shortcut"
                    class="ms-4 text-body-secondary text-lowercase"
                >
                    {{ dropdownItem.shortcut }}
                </small>
            </div>

            <slot></slot>
        </ButtonComp>
    </div>
</template>
<script
    lang="ts"
    setup
    generic="TParam = any, TAction extends (...args: any[]) => any | Promise<any> = (param: TParam) => any | Promise<any>"
>
import { ButtonComp, TooltipHelp, MarkText } from '@/components';
import type { DropdownItemButton } from '@/objects';
import { unref } from 'vue';

const props = defineProps<{
    dropdownItem: DropdownItemButton<TAction>;
    actionParam?: TParam;
}>();

const emit = defineEmits<{
    (e: 'action-run'): void;
}>();

const runAction = async () => {
    try {
        await props.dropdownItem.action(props.actionParam);
    } finally {
        emit('action-run');
    }
};

// Any attributes from parent should be set on the ButtonComp, not the li
defineOptions({
    inheritAttrs: false,
});
</script>
